module.exports = __webpack_public_path__ + "static/media/bannerarq.867aa961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arquitetodenegocios/bannerarq.png
// module id = 42
// module chunks = 0